function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M107.79 99.552s-7.245 5.352-13.534 3.511c-6.29-1.842-9.24-10.18-9.24-10.18s6.893-4.638 13.182-2.797c6.289 1.842 9.592 9.466 9.592 9.466z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.6 80.209C92.103 77.282 96.128 76 98.926 76c2.724 0 5.448 0 8.172 2.913.147.158.253.351.314.559a2.214 2.214 0 01-2.123 2.841H90.546c-1.09 0-1.67-1.288-.946-2.104zm51.97 1.911c-3.155-2.209-7.373-2.444-10.082-1.745-2.638.68-5.275 1.361-7.185 4.863-.103.19-.157.403-.165.62a2.214 2.214 0 002.766 2.22l14.275-3.684c1.056-.273 1.296-1.665.391-2.274zM91.444 96.164a5.524 5.524 0 1111.047-.114 5.524 5.524 0 01-11.047.114z",
  fill: "#212121"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M136.255 112.187c.991-.803 2.419-.476 2.537.794.441 4.75-2.178 13.026-9.792 15.519-7.341 2.404-12.9.231-15.812-2.543-.973-.927-.337-2.399.968-2.717 3.001-.732 7.923-2.07 11.27-3.69 3.735-1.808 8.304-5.317 10.829-7.363z",
  fill: "#5F3460"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.793 123.083c3.025-.758 7.513-2.023 10.633-3.533 2.679-1.297 5.787-3.469 8.263-5.349l.751 1.749a3.21 3.21 0 01-1.683 4.216l-13.273 5.702a3.21 3.21 0 01-4.217-1.682l-.474-1.103z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97.237 88.34c6.934.998 10.682 7.778 11.763 10.66l-1.709.64c-1.056-2.814-4.471-8.652-10.314-9.493-5.293-.762-8.6 1.147-10.902 2.477-.295.17-.573.33-.837.475l-.876-1.602c.242-.132.505-.285.79-.45 2.321-1.347 6.14-3.562 12.085-2.706zm39.823 1.034c-6.573.948-9.586 7.04-10.61 9.773l1.621.607c1-2.67 3.696-7.868 9.236-8.666 5.018-.724 8.153 1.086 10.337 2.346.279.16.543.313.793.45l.83-1.519c-.229-.125-.478-.27-.749-.426-2.2-1.277-5.82-3.377-11.458-2.565z",
  fill: "#212121"
});

function SvgFace3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "static/media/face-3.c9d2cba4.svg";
export { SvgFace3 as ReactComponent };